import '../Archive';
import React from "react";
import ReactDOM from "react-dom";
import QuestionsArchive from "../../react/components/questions/archive.js";
import './style.scss';


document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector(".rs-faq__search")) {
        ReactDOM.render(
            <div>
                <QuestionsArchive />
            </div>,
            document.querySelector(".rs-faq__search")
        );
    }
})

